import React, {SVGProps} from 'react';
import {DOWNLOAD_IMAGE} from '../../../constants/images.constants';

const SvgDownload = (props: SVGProps<SVGSVGElement>) => {
	return <img loading='lazy' src={DOWNLOAD_IMAGE} style={{ width: '90%', height: '90%' }} />;
};

export default SvgDownload;
